import React from "react";
import { Tag } from "antd";
import { SEGMENT_COLOR, SEGMENT_LABEL } from "../constants/npsConstants";

const NPSSegmentTag = ({ segment }) => {
  const colors = SEGMENT_COLOR[segment];
  if (!colors) return null;

  return (
    <Tag
      style={{
        color: colors.text,
        background: colors.bg,
        border: "none",
        borderRadius: 6,
        fontWeight: 600,
        fontSize: 11,
        padding: "4px 9px",
        lineHeight: 1,
      }}
    >
      {SEGMENT_LABEL[segment]}
    </Tag>
  );
};

export default NPSSegmentTag;
